import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserCredentials } from '../../../../model/user';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-users-form-credentials',
  templateUrl: './users-form-credentials.component.html',
  styleUrls: ['./users-form-credentials.component.scss']
})
export class UsersFormCredentialsComponent implements OnInit {

  @Input() mode: 'create' | 'edit';
  @Input() userCredentials: UserCredentials;
  @Output() userCredentialsChange = new EventEmitter<UserCredentials>();
  @Output() previousStep = new EventEmitter<void>();
  @Output() nextStep = new EventEmitter<void>();

  credentialsForm: FormGroup;

  passwordCheck: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.get('value').value;
    const confirmValue: string = control.get('confirmValue').value;

    if (this.mode === 'edit' && value.length === 0 && confirmValue.length === 0 ) { return null; }

    if (value.length === 0 || confirmValue.length === 0 ) { return { passwordsNotMatch: true }; }

    return value === confirmValue ? null : { passwordsNotMatch: true };

  }

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.createForm(this.userCredentials);
    if ( this.mode === 'create' && !this.userCredentials.value ) {
      this.generatePass();
    }
  }

  private createForm(user: UserCredentials): void {
    this.credentialsForm = this.formBuilder.group({
      value: [user.value],
      confirmValue: [user.confirmValue],
      temporal: [user.temporal]
    }, { validators: [this.passwordCheck] });
  }

  onPreviousStep(): void {
    this.previousStep.emit();
    this.userCredentialsChange.emit(this.credentialsForm.value);
  }

  onNextStep(): void {
    if (this.credentialsForm.valid ) {
      this.nextStep.emit();
      this.userCredentialsChange.emit(this.credentialsForm.value);
    }
  }

  public generatePass(): void {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijkl_?.-$&mnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 16; i++ ) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    this.credentialsForm.get('confirmValue').setValue(result);
    this.credentialsForm.get('value').setValue(result);
  }

}
